import { create } from "zustand";
import type { Me } from "../tg/auth";

export type EnginePhase =
  | "disconnected"
  | "connecting"
  | "awaitCode"
  | "awaitPassword"
  | "connected"
  | "error";

interface EngineState {
  phase: EnginePhase;
  me: Me | null;
  error: string | null;
  enumProgress: { seen: number; currentTitle: string } | null;
  setPhase: (p: EnginePhase) => void;
  setMe: (m: Me | null) => void;
  setError: (e: string | null) => void;
  setEnumProgress: (p: { seen: number; currentTitle: string } | null) => void;
}

export const useEngineStore = create<EngineState>((set) => ({
  phase: "disconnected",
  me: null,
  error: null,
  enumProgress: null,
  setPhase: (phase) => set({ phase }),
  setMe: (me) => set({ me }),
  setError: (error) => set({ error }),
  setEnumProgress: (enumProgress) => set({ enumProgress }),
}));
